import { InjectionToken, Provider, Type } from "@angular/core";
import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { Organisation } from "@common/ADAPT.Common.Model/organisation/organisation";
import { Observable } from "rxjs";
import { MegaPromptName } from "./mega-prompts";

export interface IMegaPromptLabel {
    promptName: MegaPromptName;
    label: string;
}

export interface IChatAiOrgProvider {
    authorisationChanged$: Observable<void>;
    promiseToCheckIfFeatureActive(name: FeatureName): Promise<boolean>;
    applicableMegaPromptLabels$: Observable<IMegaPromptLabel[]>;
    getOrganisationId(): number;
    organisationSwitching$: Observable<Organisation | undefined>;
    organisationChanged$: Observable<Organisation | undefined>;
    notifyOrganisationChangedEvent(): void;
}

export const CHAT_AI_ORG_PROVIDER = new InjectionToken<IChatAiOrgProvider>("CHAT_AI_ORG_PROVIDER");

export function provideChatAiOrgProvider(serviceClass: Type<IChatAiOrgProvider>): Provider {
    return { provide: CHAT_AI_ORG_PROVIDER, useClass: serviceClass };
}
